import {  Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { APPCONFIG } from '../../config';
import 'rxjs/Rx';
import { AdalService } from '../../shared/adal.service';
import { UserService } from '../../services/UserService';
import { AppLoaderService } from '../../../services/app-loader/app-loader.service';

@Component({
    selector: 'my-page-login',    
    template: require('./login.component.html'),
})

export class PageLoginComponent {
    AppConfig: Object;    
    validationForm: FormGroup;
    errorMessage: string;    
    constructor(private formBuilder: FormBuilder,        
        private userService: UserService,        
        private adalService: AdalService,
        private loader:AppLoaderService                   
    ) {}
    
    ngOnInit() {
        this.buildForm();                
        this.AppConfig = APPCONFIG;        
    }

    // Get User Details from Api
    buildForm() {
        this.validationForm = this.formBuilder.group({
            userName: ['', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
        });
    }
    onResetForm() {
        this.validationForm.reset();
    }
    
    logIn() {
        this.loader.open();
        this.errorMessage = "";
        // First Check EmailId is valid or Not
        this.userService.getUsers(this.validationForm.value.userName).subscribe(
            data => {
                this.loader.close();                
                if (data.IsError && data.DataObject == null) {
                    this.errorMessage = data.Error;
                }
                else {    
                    window.localStorage.setItem('emailid', this.validationForm.value.userName);
                    window.localStorage.setItem('userid', data.DataObject.UserId);
                    window.localStorage.setItem('Name', data.DataObject.Name);
                    window.localStorage.setItem('role', data.DataObject.Role);
                    window.localStorage.setItem('portalAccess',data.DataObject.PortalAccess);
                    window.localStorage.setItem('IsAdmin',data.DataObject.IsAdmin)
                    this.adalService.login();
                }
            },
            error => {
                this.loader.close();                
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/extra-pages/login/login.component.ts